import { FC, memo } from 'react';

import { dom } from 'app/utils';
import { IComponent } from './types';

import light from 'assets/images/th-logo-light.png';
import dark from 'assets/images/th-logo-dark.png';

export interface ILogo extends IComponent { }

export const Logo: FC<ILogo> = memo(({ id, className, style }: ILogo) => {
  const isDark = false; // useMatchMedia('(prefers-color-scheme: dark)');

  const props: any = { id, style,
    className: dom.className('i-component', 'i-logo', className),
    src: (isDark ? dark : light),
  };

  return (<img { ...props } alt="logo" />);
})
